import { AfterViewInit, Directive, ElementRef, Host } from '@angular/core';

import { TwcSelectComponent } from '@topcon/twc-angular';

export const BOUNDARY_ATTR = 'data-parent-boundary' as const;

/**
 * This directive works with the SetParentBoundaryDirective in order
 * to help setting the boundary property of a TwcSelect component
 * to a parent element exisiting in another component.
 * It will look for an ancestor element having the data-parent-boundary
 * attribute and set it as the TwcSelect boundary.
 */
@Directive({
    selector: 'twc-select[cwFindParentBoundary]',
    standalone: false,
})
export class FindParentBoundaryDirective implements AfterViewInit {
    constructor(
        @Host() private twcSelect: TwcSelectComponent,
        private selectRef: ElementRef<HTMLSelectElement>
    ) {}

    ngAfterViewInit(): void {
        requestAnimationFrame(() => {
            const select = this.selectRef.nativeElement;
            const boundary = select.closest<HTMLElement>(`[${BOUNDARY_ATTR}]`);

            if (boundary) {
                this.twcSelect.boundary = boundary;
            }
        });
    }
}
